import Device from 'Faster/model/Device';

class DeviceData {
  public readonly platform?: string;
  public readonly system?: string;
  public readonly systemVersion?: string;
  public readonly manufacturer?: string;
  public readonly deviceModel?: string;
  public readonly appVersion?: string;
  public readonly sdkVersion?: string;
  public readonly vendorId?: string;
  public readonly advertisingId?: string;
  public readonly pushToken?: string;
  public readonly cloudId?: string;
  public readonly carrierId?: string;
  public readonly timezone?: string;
  public readonly language?: string;
  public readonly isNewInstall?: boolean;
  public readonly properties?: object;

  public constructor(
    platform?: string,
    system?: string,
    systemVersion?: string,
    manufacturer?: string,
    deviceModel?: string,
    appVersion?: string,
    sdkVersion?: string,
    vendorId?: string,
    advertisingId?: string,
    pushToken?: string,
    cloudId?: string,
    carrierId?: string,
    timezone?: string,
    language?: string,
    isNewInstall?: boolean,
    properties?: object
  ) {
    this.platform = platform;
    this.system = system;
    this.systemVersion = systemVersion;
    this.manufacturer = manufacturer;
    this.deviceModel = deviceModel;
    this.appVersion = appVersion;
    this.sdkVersion = sdkVersion;
    this.vendorId = vendorId;
    this.advertisingId = advertisingId;
    this.pushToken = pushToken;
    this.cloudId = cloudId;
    this.carrierId = carrierId;
    this.timezone = timezone;
    this.language = language;
    this.isNewInstall = isNewInstall;
    this.properties = properties;
  }

  public static fromDevice(device: Device): DeviceData {
    return new this(
      device.platform,
      device.system,
      device.systemVersion,
      device.manufacturer,
      device.deviceModel,
      device.appVersion,
      device.sdkVersion,
      device.vendorId,
      device.advertisingId,
      device.pushToken,
      device.cloudId,
      device.carrierId,
      device.timezone,
      device.language,
      device.isNewInstall,
      device.properties
    );
  }
}

export default DeviceData;
